import React from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/HpPrinter";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import BottomFooter from "../components/BottomFooter";
import { Helmet } from "react-helmet-async";

const ShopPage = () => {
  return (
    <>
      <Helmet>
        <title>HP Printers | Awaneez</title>
      </Helmet>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderOne */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"HP Printers"} />

      {/* ShopSection */}
      <ShopSection />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default ShopPage;
